/**
 * Quién usa mensajes en cnc-admin: un empleado (ROLE_EMPLEADO) o un comercial (ROLE_COMERCIAL; la API
 * le enseña solo las conversaciones de sus clientes nacidas en Comercial), y en los dos casos con
 * ROLE_MENSAJES (grupo «Mensajes» o el rol en su propio grupo; ver GrupoMensajes). El resto no ve ni el
 * sobre, ni la acción de los listados, ni la ruta, y no se le sondea nada. En cnc-client basta ROLE_MENSAJES.
 */
export const ROL_MENSAJES = 'ROLE_MENSAJES';

type SesionConRoles = {isLogged(): boolean; hasRole(rol: string): boolean};

export function puedeUsarMensajes(sesion: SesionConRoles): boolean {
    return sesion.isLogged() && sesion.hasRole(ROL_MENSAJES)
        && (sesion.hasRole('ROLE_EMPLEADO') || sesion.hasRole('ROLE_COMERCIAL'));
}

/** Casilla «Mensajes activados» de la ficha del cliente: solo empleados (al comercial la API le da 403). */
export function gestionaMensajesDeClientes(sesion: SesionConRoles): boolean {
    return sesion.isLogged() && sesion.hasRole('ROLE_EMPLEADO') && sesion.hasRole(ROL_MENSAJES);
}
